import React, { useState, useEffect } from "react";
import { Typography } from "@mui/material";
import { FruitifyContainer } from "../../../shared-components/Containers";
import { useParams, useSearchParams } from "react-router-dom";
import { useApiClient } from "../../../api";
import GeneralLoading from "../../../shared-components/Loading";
import { withPageTracking } from "../../../services/postHog";
import { IdentifierAutoComplete } from "../../assignment/components/IdentifierAutoComplete";
import { QuizSubmission } from "../components/QuizSubmission";

const DirectQuizSubmissionTokenView = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();

  const user = searchParams.get("user");
  const token = searchParams.get("token");

  const ApiClient = useApiClient();

  const [tokenIsValid, setTokenIsValid] = useState(false);
  const [tokenErrorMessage, setTokenErrorMessage] = useState("");
  const [checkingToken, setCheckingToken] = useState(true);
  const [identifiers, setIdentifiers] = useState([]);
  const [quizGroup, setQuizGroup] = useState(null);
  const [identifier, setIdentifier] = useState({});
  const [isIndependentUser, setIsIndependentUser] = useState(false);

  useEffect(() => {
    if (user && token) {
      verifyUploadToken();
    } else {
      setTokenErrorMessage(
        "Invalid upload link or the link has expired. Please request a new one.",
      );
      setCheckingToken(false);
    }
  }, [user, token]);

  useEffect(() => {
    if (quizGroup) {
      setIdentifiers(quizGroup.schoolClass.students);
    }
  }, [quizGroup]);

  const verifyUploadToken = async () => {
    try {
      const response = await ApiClient.quiz.verifyUploadToken({
        user: user,
        quizGroup: id,
        token: token,
      });
      if (response.success) {
        setTokenIsValid(response.isValid);
        if (response.isValid) {
          setQuizGroup(response.quizGroup);
        } else {
          setTokenErrorMessage(response.message);
        }
      } else {
        setTokenIsValid(false);
        setTokenErrorMessage(
          response.message || "Invalid upload URL or credentials",
        );
        console.error("The token is not valid");
      }
      setIsIndependentUser(response.isIndependentUser);
    } catch (error) {
      console.error("The token is not valid", error);
      setTokenIsValid(false);
      setTokenErrorMessage("Unable to verify upload link. Please try again.");
    } finally {
      setCheckingToken(false);
    }
  };

  const handleIdentifierChange = (identifier) => {
    setIdentifier(identifier);
  };

  if (checkingToken) {
    return <GeneralLoading />;
  }

  if (!tokenIsValid) {
    return (
      <FruitifyContainer
        p={2}
        sx={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "center",
          width: "100%",
        }}
      >
        <Typography
          variant="h6"
          component="p"
          role="alert"
          sx={{ width: "100%", maxWidth: 720, overflowWrap: "anywhere" }}
        >
          {tokenErrorMessage || "Invalid upload URL or credentials"}
        </Typography>
      </FruitifyContainer>
    );
  }
  return (
    <FruitifyContainer p={2}>
      <IdentifierAutoComplete
        availableIdentifiers={identifiers}
        setIdentifier={handleIdentifierChange}
        identifier={identifier}
        identifierWarningMessage={""}
        isIndependentUser={isIndependentUser}
      />
      <QuizSubmission
        identifier={identifier}
        quizGroup={quizGroup}
        setIdentifier={setIdentifier}
        tokenView
      />
    </FruitifyContainer>
  );
};

export default withPageTracking(DirectQuizSubmissionTokenView, {
  feature: "direct-quiz-submission",
});
